import React, { useEffect, useState } from "react";
import { InputGroup, Form } from "react-bootstrap";
import { Alert, Avatar, CardHeader } from "@mui/material";
import { getChat, getProyectos, getUsuariosChat } from "../componentes/api.js";
import { RUTA_SERVER } from "../componentes/config.js";

const Chat = (props) => {
  const [usuarios, setUsuarios] = useState([]);
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [idProyecto, setIdProyecto] = useState(props.idProyecto);
  const [nbreProyecto, setNbreProyecto] = useState(props.nbreProyecto);
  const [proyectos, setProyectos] = useState([]);
  const [idDestino, setIdDestino] = useState("");
  const [nbreDestino, setNbreDestino] = useState("");
  const [mostrarProyectos, setMostrarProyectos] = useState(false);

  useEffect(() => {
    const recibirMsg = (message) => {
      setMessages([message, ...messages]);
    };

    props.socket.on("message", recibirMsg);

    return () => {
      props.socket.off("message", recibirMsg);
    };
  }, [messages]);

  useEffect(() => {
    setIdDestino(""); //Limpio el destino

    if (props.tipoParticipante === 1) {
      //Es super usuario
      setMostrarProyectos(true);
      cargarProyectos();
    } else {
      setIdProyecto(props.idProyecto);
      setMostrarProyectos(false);
      cargarUsuarios(props.idProyecto);
      cargarConversacion("", "");
    }
  }, []);

  const asignarUsuario = (event, id, nbre) => {
    event.preventDefault();
    setIdDestino(id);
    setNbreDestino(nbre);
    cargarConversacion(props.idUsuario, id);
  };

  const asignarProyecto = (event) => {
    event.preventDefault();
    var combo = document.getElementById("idProyecto");
    var selected = combo.options[combo.selectedIndex].text;
    setIdProyecto(event.target.value);
    setNbreProyecto(selected);
    cargarUsuarios(event.target.value);
  };

  const cargarConversacion = async (idOrigen, idDestino) => {
    if (nbreProyecto !== undefined) {
      try {
        const response = await getChat({
          idProyecto: idProyecto,
          idOrigen: idOrigen,
          idDestino: idDestino,
        });
        setMessages(response.data);
      } catch (error) {
        props.mostrarMsg([
          "ERROR",
          "Ocurrio un error al cargar las conversaciones",
          error,
        ]);
      }
    }
  };

  const cargarProyectos = async () => {
    try {
      const response = await getProyectos();
      setProyectos(response.data);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar los Proyectos",
        error,
      ]);
    }
  };

  const cargarUsuarios = async (proyecto) => {
    try {
      const response = await getUsuariosChat({
        idProyecto: proyecto,
        idUsuario: props.idUsuario,
      });
      setUsuarios(response.data);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar los Usuarios",
        error,
      ]);
    }
  };

  const enviarMsg = (event) => {
    event.preventDefault();
    const newMessage = {
      Msg: message,
      Fecha: new Date().toISOString(),
      Origen: props.idUsuario,
      Destino: idDestino,
      NbreOrigen: props.nbreUsuario,
      NbreDestino: nbreDestino,
      Proyecto: idProyecto,
    };
    setMessages([newMessage, ...messages]);
    props.socket.emit("message", newMessage);
    setMessage("");
  };

  // Muestra el mensaje del chat
  const mostrarMsgChat = (variante, origen, fecha, hora, msg) => {
    return (
      <div className="shadow-lg p-3 mb-5 bg-body-tertiary rounded">
        <div className="form-text">{origen}</div>
        <p style={{ fontSize: 10 }}>
          {fecha} - {hora}
        </p>
        <div className="form-text">{msg}</div>
      </div>
    );
  };

  return (
    <div className="container-fluid">
      <div className="row card shadow m-1">
        <Alert severity="success">
          <strong>CHAT CORPORATIVO</strong>
        </Alert>

        <div className="container-fluid">
          <div className="row mt-2">
            <div className="input-group form-floating">
              <select
                name="idProyecto"
                id="idProyecto"
                className="form-select form-control"
                aria-label="Proyecto"
                value={idProyecto}
                onChange={(event) => {
                  asignarProyecto(event);
                }}
              >
                <option key="0" value="0">
                  Proyecto...
                </option>
                {proyectos.map((reg) => {
                  return (
                    <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                      {" "}
                      {reg.Nbre}{" "}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          {/* Fila para el proyecto y el campo de conversación */}
          <div className="row">
            <div className="col-sm-3 mt-3 m-2">
              {/* Botón de acceso a todos los usuarios del proyecto */}
              <div className="row">
                <a
                  href="#div_conversacion"
                  className="btn btn-primary"
                  onClick={(event) => cargarConversacion("", "")}
                >
                  {nbreProyecto !== undefined
                    ? nbreProyecto
                    : "Sin seleccionar un Proyecto"}
                </a>
              </div>
            </div>

            {/* Columna para los mensaje */}
            <div className="col-sm-8">
              <form onSubmit={enviarMsg}>
                <div className="input-group mb-3">
                  <InputGroup>
                    <Form.Control
                      autoFocus={true}
                      as="textarea"
                      className="form-control mt-3"
                      placeholder="Escriba un mensaje..."
                      aria-label="Escriba un mensaje..."
                      aria-describedby="button-addon2"
                      onChange={(event) => {
                        setMessage(event.target.value);
                      }}
                      value={message}
                    />
                    {/* <InputGroup.Text>With textarea</InputGroup.Text> */}
                    <button
                      className="btn btn-primary mt-3"
                      type="submit"
                      //type="button"
                      id="button-addon2"
                      //onClick={(event) => {enviarMsg(event)}}
                    >
                      Enviar
                    </button>
                  </InputGroup>
                </div>
              </form>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              {/* Monta los usuarios del proyecto */}
              {usuarios.map((reg, i) => {
                return (
                  <a
                    href="#div_conversacion"
                    className="btn"
                    key={i}
                    onClick={(event) =>
                      asignarUsuario(event, reg.Id, reg.Nbres)
                    }
                  >
                    <CardHeader
                      avatar={<Avatar src={RUTA_SERVER + "/" + reg.Foto} />}
                      title={reg.Nbres}
                      subheader={reg.Municipio.toLowerCase()}
                    />
                  </a>
                );
              })}
            </div>

            {/* Columna para el movimiento de mensajes */}
            <div
              className="col-sm-8"
              id="div_conversacion"
              style={{ overflow: "auto", height: 550 }}
            >
              {messages.length > 0 &&
                messages.map((reg, i) => {
                  return (
                    <div className="row mt-1" key={i}>
                      {reg.Origen === props.idUsuario ? (
                        <>
                          <div className="col-sm-5"></div>
                          <div className="col-sm-7 text-right">
                            {mostrarMsgChat(
                              "info",
                              reg.NbreOrigen,
                              reg.Fecha.substring(0, 10),
                              reg.Fecha.substring(11, 16),
                              reg.Msg
                            )}
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="col-sm-8">
                            {mostrarMsgChat(
                              "danger",
                              reg.NbreOrigen,
                              reg.Fecha.substring(0, 10),
                              reg.Fecha.substring(11, 16),
                              reg.Msg
                            )}
                          </div>
                          <div className="col-sm-4"></div>
                        </>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chat;
